import { Component, OnInit, Input, QueryList, ViewChildren, OnChanges } from '@angular/core';
import { NJDocDefTemplate, DocdefDataVM, NJDocData, NJReadDocDefTemplateLookup, DOData } from '../DOData';
import { DocDefPrimLibService} from '../../doc-def-prim-lib.service';
import { DodropDownComponent } from '../dodrop-down/dodrop-down.component';
import { DotextBoxAutocompleteComponent } from '../dotext-box-autocomplete/dotext-box-autocomplete.component';
//import { DOData, DocDefPrimLibService, SectionAccordionComponent, SectionTableComponent } from 'doc-def-prim-lib';
@Component({
    selector: 'cylib-dropdown-autocomplete',
    templateUrl: './dropdown-autocomplete.component.html',
    styleUrls: ['./dropdown-autocomplete.component.css']
})
export class DropdownAutoCompleteComponent implements OnInit, OnChanges {
    @Input() DocDefTemplate: NJDocDefTemplate
    @Input() customParameters: any
    @Input() DocData: NJDocData
    @Input() public loaderKey: string;
    @Input() skipPostDocDefData: boolean = false;

    @Input() lstDocData: Array<NJDocData> = new Array<NJDocData>();
    @Input() lstChildDocDefTemplate: Array<NJDocDefTemplate>;
    @Input() lstDocDefTemplateLookup: Array<NJReadDocDefTemplateLookup>;
    @Input() allowDoubleClick: boolean;

    @Input() isValid: boolean = true;
    @Input() isEnabled: boolean = true;
    @Input() public hasEvent: boolean = false;
    public ddTemp: NJDocDefTemplate;
    public autoComleteTemp: NJDocDefTemplate;
    public isTextValid: boolean = true;
    public ddData: NJDocData;
    public txtData: NJDocData;
    public WrapperObject: NJDocData;
    public initialized: boolean = false;

    constructor(private data: DocDefPrimLibService) { }

    @ViewChildren(DodropDownComponent) DropDownsComponents: QueryList<DodropDownComponent>;
    @ViewChildren(DotextBoxAutocompleteComponent) DotextBoxAutocompleteComponents: QueryList<DotextBoxAutocompleteComponent>;

    ngOnInit() {

        let searchItemText: NJDocData = this.lstDocData.filter(x => x.docDefTemplateID == this.lstChildDocDefTemplate[1].docDefTemplateID)[0];


        this.WrapperObject = new NJDocData();
        this.WrapperObject.docDataHdrId = -1;
        this.WrapperObject.docDefDataRowID = 0;
        this.WrapperObject.docDefDataRowParID = 0;
        this.WrapperObject.docDefTemplateID = this.DocDefTemplate.docDefTemplateID;
        if (searchItemText.dataValue != null)      
            this.WrapperObject.dataValue = searchItemText.dataValue;
        else
            this.WrapperObject.dataValue = "";


        //if (this.DocData == null) {
        //    // user id
        //    this.DocData = new NJDocData();
        //    this.DocData.docDataHdrId = -1;
        //    this.DocData.docDefDataRowID = 0;
        //    this.DocData.docDefDataRowParID = 0;
        //    this.DocData.docDefTemplateID = this.DocDefTemplate.docDefTemplateID;
        //    //this.DocData.dataValue = "NJSFOSTE";
        //    this.DocData.dataValue = "SHELISA FOSTER";
        //    this.lstDocData.push(this.DocData);

        //    // dropdown
        //    let DocDataDropDown = new NJDocData();
        //    DocDataDropDown.docDataHdrId = -1;
        //    DocDataDropDown.docDefDataRowID = 0;
        //    DocDataDropDown.docDefDataRowParID = 0;
        //    DocDataDropDown.docDefTemplateID = this.lstChildDocDefTemplate[2].docDefTemplateID;
        //    DocDataDropDown.dataValue = "C2";
        //    this.lstDocData.push(DocDataDropDown);
        //}

        let autoCompleteSelectedID: string = "";

        let searchItem: NJDocData = this.lstDocData.filter(x => x.docDefTemplateID == this.lstChildDocDefTemplate[0].docDefTemplateID)[0];

        if (searchItem.dataValue != null)
            autoCompleteSelectedID = searchItem.dataValue;

        if (this.lstDocDefTemplateLookup == null) {
            // set default lookup item to the dropdown
            this.lstDocDefTemplateLookup = new Array<NJReadDocDefTemplateLookup>();

            let DocDefTemplateLookup: NJReadDocDefTemplateLookup = new NJReadDocDefTemplateLookup();
            DocDefTemplateLookup.longDesc = "No Data";
            DocDefTemplateLookup.longDesc2 = "No Data";
            DocDefTemplateLookup.shortDesc = "NoData";
            DocDefTemplateLookup.lookupId =   2;
            DocDefTemplateLookup.lookupTypeId = -1;
            DocDefTemplateLookup.active = "N";
            this.lstDocDefTemplateLookup.push(DocDefTemplateLookup);

        }

        let WrapperTemplateId: Number = this.DocDefTemplate.docDefTemplateID;

        // **************** list of children ****************
        // this.lstChildDocDefTemplate[0]  = code
        // this.lstChildDocDefTemplate[1]  = description
        // this.lstChildDocDefTemplate[2]  = dropdown

        // ItemTemplate for Dropdown 
        this.ddTemp = DocDefPrimLibService.createNew(this.lstChildDocDefTemplate[2]);


        // ItemTemplate for autocomplate
        this.autoComleteTemp = DocDefPrimLibService.createNew(this.DocDefTemplate);


        // query to get data for dropdown
        let template = this.lstChildDocDefTemplate.filter(function (item) {
            return item.tType == 'DropDownChild';
        });
     
        if (this.lstDocData.length > 0) {
            let tmpDdData = (this.lstDocData.filter(function (item) {
                return item.docDefTemplateID == template[0].docDefTemplateID
            }))[0];

            this.ddData = DocDefPrimLibService.createNew(tmpDdData);
        }
        else
            this.ddData = null;

        this.txtData = DocDefPrimLibService.createNew(this.WrapperObject);

        //if (this.lstDocData.length > 0) {
        //    // query to get data for wrapper object
        //    let tmpTxtData = (this.lstDocData.filter(function (item) {
        //        return item.docDefTemplateID == WrapperTemplateId
        //    }))[0];
        //    this.txtData = DocDefPrimLibService.createNew(tmpTxtData);
        //}
        //else
        //    this.txtData = null;

        this.isTextValid = this.isValid;

        this.initialized = true;

        if (autoCompleteSelectedID != "")
            this.getListLookupeData(autoCompleteSelectedID);
    }
    onclickBut(ev: DOData) {

        //  drop to autocomplete box
        //if (ev.njDocDefTemplate.tType == "DropDownChild") {
        //    // get a reference to the dropdown
        //    let dropDown = this.DropDownsComponents.filter(t => t.DocDefTemplate.templateCode == ev.njDocDefTemplate.templateCode)[0];

        //    // get a reference to the autocomplete
        //    let autoComplete = this.DotextBoxAutocompleteComponents.filter(t => t.DocDefTemplate.templateCode == ev.njDocDefTemplate.templateCode)[0];

        //    // Search dropdown
        //    autoComplete.searchClient(ev.njDocData.dataValue);
        //}

        if (ev.njDocDefTemplate.tType == "DropDownAutoComplete") {
            if (ev.njDocData.dataValue != null) {
                if (ev.njDocData.dataValue !="")
                    this.getListLookupeData(ev.njDocData.dataValue);
            }
        }
    }


    private getListLookupeData(term: string) {
        let lstDocData: DocdefDataVM = new DocdefDataVM();
        let txtDocData: NJDocData = new NJDocData();
        txtDocData.dataValue = term;
        txtDocData.docDefTemplateID = this.DocDefTemplate.docDefTemplateID
        lstDocData.loaderKey = this.loaderKey;
        lstDocData.docdata.push(txtDocData);

        this.data.getDynamicLookupData(lstDocData)
            .subscribe((ret: boolean) => {
                if (ret) {
                    this.lstDocDefTemplateLookup = [];
                    this.lstDocDefTemplateLookup = this.data.lstDynamicLookup;

                    let dropDown: DodropDownComponent = this.DropDownsComponents.first;
                    dropDown.lstDocDefTemplateLookup = this.lstDocDefTemplateLookup;
                    dropDown.LookupId = this.lstDocDefTemplateLookup[0].lookupId.toString();
                    if (this.ddData.dataValue) {
                        dropDown.resetSelectionById(this.ddData.dataValue);
                    } else {
                        dropDown.resetSelection();
                    }

                    this.ngOnChanges();

                }
            }, (err: any) => console.log(err), () => {
                //Broadcast an event to indicate this field has been initialized, useful for disabling or enabling cascaded controls

            });
    }


    ngOnChanges(): void {

    }

    onTabEvent(ev: any) {
    }


}
